import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteNumberOfScan,
  updateNumberOfScanItem,
} from "../../../../redux/slices/multiUrl";
import { handleLink } from "../../../../hooks/helpers";
import InputText from "../../../../components/input/inputText";
import { TrashIcon } from "../svg";
import { Button, Col, Form } from "react-bootstrap";
import { MAX_LINK_LENGTH } from "../../../../constants/inputValues";

export default function ScanItem({ scan, scanIndex, error }) {
  const { numberOfScans, lang, errorMsg } = useSelector((state) => ({
    numberOfScans: state.multiUrl.numberOfScans,
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
  }));
  const { id, scanNumber, link, linkValid } = scan;

  const dispatch = useDispatch();

  const handleNumber = (e) => {
    let str = e.target.value;
    if (/^[0-9]*$/gi.test(str)) {
      const number = Number(str) > 100000 ? 100000 : Number(str);
      dispatch(updateNumberOfScanItem({ id, scanNumber: number }));
    }
  };

  return (
    <>
      <Col xs={12} md={11}>
        <div className="d-flex justify-content-between align-items-center fw-bold mb-1 mt-4">
          <small>
            {lang.multiUrl[11]} {scanIndex}
          </small>
          {numberOfScans.length > 1 && (
            <Button
              variant="link"
              onClick={() => dispatch(deleteNumberOfScan(id))}
              className="p-0 cursor-pointer"
            >
              <TrashIcon
                style={{
                  color: "#F44336",
                  cursor: "pointer",
                }}
              />
            </Button>
          )}
        </div>
      </Col>

      <InputText
        valid={scanNumber >= 0}
        error={error && scanNumber < 0}
        name="scanNumber"
        value={scanNumber}
        onChange={handleNumber}
        placeholder={lang.multiUrl[12]}
        popoverText={lang.multiUrl[34]}
      >
        {error && scanNumber < 0 && (
          <Form.Text className="text-danger">{lang.multiUrl[2]}</Form.Text>
        )}
      </InputText>

      <InputText
        valid={linkValid && link.length > 3 && link.length <= MAX_LINK_LENGTH}
        error={
          (!linkValid && link.length > 3) ||
          (error && !link.length && !linkValid) ||
          link.length > MAX_LINK_LENGTH
        }
        type="link"
        name="scanNumberLink"
        value={link}
        onChange={(e) =>
          handleLink(
            e.target.value,
            (linkValid) => dispatch(updateNumberOfScanItem({ id, linkValid })),
            (link) => dispatch(updateNumberOfScanItem({ id, link }))
          )
        }
        placeholder={lang.multiUrl[13]}
        popoverText={lang.multiUrl[35]}
      >
        {linkValid === false && link.length > 3 && (
          <Form.Text className="text-danger">
            {lang.link[2]}: https://me-qr.com/
          </Form.Text>
        )}
        {error && !link.length && !linkValid && (
          <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
        )}
        {!linkValid && link.length > 0 && link.length < 4 && (
          <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
        )}
        {link.length > MAX_LINK_LENGTH && (
          <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
        )}
      </InputText>
    </>
  );
}
